export default __webpack_public_path__ + "static/media/tutorial-install-bot-3.8b001a84.png";